import {AbstractControl, ValidatorFn} from '@angular/forms';

export function isValidPesel(pesel: string): boolean {
  const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  let sum = 0;
  const controlNumber = parseInt(pesel.substring(10, 11), 10);

  for (let i = 0; i < weight.length; i++) {
    sum += (parseInt(pesel.substring(i, i + 1), 10) * weight[i]);
  }
  sum = sum % 10;
  return (10 - sum) % 10 === controlNumber;
}

export function validPesel(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null =>
    (!control.value || isValidPesel(control.value))
      ? null : {invalidPesel: true};
}
